import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

import { DeleteUsersRequest, UpdateUserRequest } from 'projects/shared/services/inspection-companies/inspection-company.user.service';
import { UsersDeletedResponse } from 'projects/shared/services/inspection-companies/models/users/users-deleted-response';
import { RoleResponse } from 'projects/shared/services/roles/models/role.response';
import { Permission } from 'projects/shared/directives/if-permission.directive';

import { EditUserModalComponent, User } from './edit-user-modal.component';

@Component({
  selector: 'shared-edit-user-button',
  standalone: false,
  template: `<mac-button
      *ifPermission="updateUserPermission"
      icon="edit"
      variant="text"
      size="small"
      padding="compact"
      (click)="openUpdateUserModal()" />

    <shared-edit-user-modal
      #editUserModal
      [roles$]="roles$"
      [user]="user"
      [updateUserAction]="updateUserAction"
      [deleteUsersAction]="deleteUsersAction"
      (userUpdated)="onUserUpdated()"
      (userDeleteModalClosed)="onUserDeleteModalClosed($event)" />`,
})
export class EditUserButtonComponent {
  readonly updateUserPermission = Permission.UpdateInspectionCompanyUsers;
  @Input() user: User;
  @Input() updateUserAction: (userId: number, model: UpdateUserRequest) => Observable<void>;
  @Input() deleteUsersAction: (model: DeleteUsersRequest) => Observable<UsersDeletedResponse>;
  @Input({ required: true }) roles$: Observable<RoleResponse[]>;

  @Output() userUpdated = new EventEmitter();
  @Output() userDeleted = new EventEmitter();

  @ViewChild(EditUserModalComponent) editUserModal: EditUserModalComponent;

  public openUpdateUserModal() {
    this.editUserModal.open();
  }

  public onUserUpdated() {
    this.editUserModal.close();
    this.userUpdated.emit();
  }

  public onUserDeleteModalClosed(isDeleted: boolean) {
    this.editUserModal.close();
    if (isDeleted) {
      this.userDeleted.emit();
    }
  }
}
